<template>
  <div>
    <vx-card class="mb-4">
      <div class="flex items-center justify-between">
        <div class="vx-col w-1/4">
          <label style="font-size: 25px">{{ $t('role') }}: </label> <label style="font-size: 20px">{{
            permission.role[$i18n.locale]
          }}</label>

        </div>

        <div class="vx-col w-2/5 flex items-center gap-2">
          <vs-button
            class="w-1/2"
            color="success"
            type="filled"
            @click="downloadExcelFile"
          >
            <div class="flex">

              <div class="loader" v-if="loaderExcel"></div>
              <span class="ml-3">
          {{ $t("modules.logging.download_excel") }}

          </span>
            </div>
          </vs-button>
          <vs-button
            class="w-1/2"
            color="primary"
            type="filled"
            @click="saveData"
          >
            {{ $t("save") }}
          </vs-button>
        </div>

      </div>
    </vx-card>


    <div class="gap-3 permission">
      <ul>
        <li v-for="item in getPermissions.results" :key="item.id" class="hoverEffect p-4  mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ;  justify-content: space-between"
            @click="openChildren(item,'first')" :class="item.module.id === first ? 'hovered':'bg-white'">
          <span v-if="item.module.unique_name === 'index_p'" disabled
          >{{ item.module.name[$i18n.locale] }}</span>
          <span v-else>{{ item.module.name[$i18n.locale] }}</span>
          <div class="flex items-center">
          <span v-if="item.has_children" class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
            xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-chevron-right w-4 h-4"><polyline points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" :disabled="itemDisabled(item)" @input="getData(item,'first')"
                     class="toggle-checkbox " type="checkbox" checked>
              <div v-if="item.module.unique_name === 'index_p'" class="toggle-switch"
                   style="background: #597ab5 !important;"></div>
              <div v-else class="toggle-switch"></div>
            </label>
          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_FIRST_CHILDREN.results" :key="item.id" @click="openChildren(item,'second')"
            class="hoverEffect  p-4  mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === second ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
             <span v-if="item.has_children" class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
               xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="feather feather-chevron-right w-4 h-4"><polyline
               points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'second')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_SECOND_CHILDREN.results" :key="item.id" @click="openChildren(item,'third')"
            class="hoverEffect  p-4  mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === third ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'third')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_THIRD_CHILDREN.results" :key="item.id" @click="openChildren(item,'fourth')"
            class="hoverEffect  p-4 mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === fourth ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'fourth')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_FOURTH_CHILDREN.results" :key="item.id" @click="openChildren(item,'fifth')"
            class="hoverEffect  p-4  mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === fifth ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'fifth')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_FIFTH_CHILDREN.results" :key="item.id" @click="openChildren(item,'sixth')"
            class="hoverEffect  p-4 mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === sixth ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'sixth')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_SIXTH_CHILDREN.results" :key="item.id" @click="openChildren(item,'seven')"
            class="hoverEffect  p-4 mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === seven ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'seven')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_SEVEN_CHILDREN.results" :key="item.id" @click="openChildren(item,'eight')"
            class="hoverEffect  p-4 mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === eight ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'eight')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>
          </div>
        </li>
      </ul>
      <ul>
        <li v-for="item in GET_EIGHT_CHILDREN.results" :key="item.id" @click="openChildren(item,'nine')"
            class="hoverEffect  p-4 mb-3 cursor-pointer "
            style="border-radius: 10px ;display: flex ; justify-content: space-between"
            :class="item.module.id === nine ? 'hovered':'bg-white'">
          {{ item.module.name[$i18n.locale] }}
          <div class="flex items-center">
                        <span v-if="item.has_children"
                              class="mr-2   feather-icon select-none relative feather-grp-header-arrow"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-chevron-right w-4 h-4"><polyline
                          points="9 18 15 12 9 6"></polyline></svg></span>
            <label class="toggle" @click.stop>
              <input v-model="item.is_active" @input="getData(item,'nine')" class="toggle-checkbox" type="checkbox"
                     checked>
              <div class="toggle-switch"></div>
            </label>

          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loaderExcel: false,
      first: '',
      second: '',
      third: '',
      fourth: '',
      fifth: '',
      sixth: '',
      seven: '',
      eight: '',
      nine: '',
      role_id: null,
      all_ids: [],
      true_ids: [],
      false_ids: [],
      permission: {
        switch: false,
        role: null,
      }
    };
  },
  components: {
    vSelect
  },
  computed: {
    ...mapGetters('users', ['getRoles', 'getPermissions', 'getFourthChildren', 'getFifthChildren', 'getFirstChildren', 'getSecondChildren', 'getThirdChildren', 'getSixthChildren', 'getSevenChildren', 'getEightChildren']),
    GET_FIRST_CHILDREN() {
      return this.getFirstChildren
    },
    GET_SECOND_CHILDREN() {
      return this.getSecondChildren
    },
    GET_THIRD_CHILDREN() {
      return this.getThirdChildren
    },
    GET_FOURTH_CHILDREN() {
      return this.getFourthChildren
    },
    GET_FIFTH_CHILDREN() {
      return this.getFifthChildren
    },
    GET_SIXTH_CHILDREN() {
      return this.getSixthChildren
    },
    GET_SEVEN_CHILDREN() {
      return this.getSevenChildren
    },
    GET_EIGHT_CHILDREN() {
      return this.getEightChildren
    }
  },
  watch: {
    GET_FIRST_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }

    },
    GET_SECOND_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_THIRD_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_FOURTH_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_FIFTH_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_SIXTH_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_SEVEN_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    },
    GET_EIGHT_CHILDREN(val) {
      let data = this.findLastIsActiveValues(this.all_ids)
      if (val.results) {
        val.results.map((item) => {
          if (Object.keys(data).length) {
            for (const d in data) {
              if (Number(d) === item.module.id) {
                return item.is_active = data[d]
              }
            }
          } else {
            return item
          }
        })
      }
    }
  },
  methods: {
    ...mapActions('users', [
      'fetchRoles',
    ]),
    ...mapActions('users', [
      'FETCH_PERMISSIONS_LIST',
      'FETCH_PERMISSIONS_CHILDREN',
      'UPDATE_PERMISSIONS_LIST',
      'FETCH_DATA_FOR_EXCEL_PERMISSION'
    ]),
    itemDisabled(val) {
      if (val.module.unique_name === 'index_p') {
        return true
      }
    },
    async saveData() {
      this.true_ids = []
      this.false_ids = []
      let data = this.findLastIsActiveValues(this.all_ids)
      for (let item in data) {
        if (data[item]) {
          this.true_ids.push(item)
        } else {
          this.false_ids.push(item)
        }
      }

      let permissionData = {
        role: this.$route.params.id,
        true_ids: this.true_ids,
        false_ids: this.false_ids
      }
      await this.UPDATE_PERMISSIONS_LIST(permissionData)
        .then(() => {
          // this.$router.push({path: '/settings/permission/'})
          this.$vs.notify({
            title: "Успешно",
            text: "",
            color: "success",
          });

        })
        .catch(() => {
          this.$vs.notify({
            title: this.$t('error'),
            text: ``,
            color: "danger",
          });

        });

    },
    findLastIsActiveValues(arr) {
      const lastIsActiveMap = {};

      // Iterate through the array
      for (let i = 0; i < arr.length; i++) {
        const obj = arr[i];
        lastIsActiveMap[obj.id] = obj.is_active;
      }

      return lastIsActiveMap;
    },
    downloadExcelFile() {
      this.loaderExcel = true
      this.FETCH_DATA_FOR_EXCEL_PERMISSION({excel: true, id: this.$route.params.id}).then((res) => {
        this.loaderExcel = false
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Разрешение.xls`
        );
        document.body.appendChild(link);
        link.click();
      });
    },
    getData(val, name) {
      if (name === 'first' && !val.is_active) {
        this.first = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'first' && val.is_active) {
        this.getFirstChildren.results = []
        this.getSecondChildren.results = []
        this.getThirdChildren.results = []
        this.getFourthChildren.results = []
        this.getFifthChildren.results = []
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'second' && !val.is_active) {
        this.second = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'second' && val.is_active) {
        this.getSecondChildren.results = []
        this.getThirdChildren.results = []
        this.getFourthChildren.results = []
        this.getFifthChildren.results = []
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'third' && !val.is_active) {
        this.third = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'third' && val.is_active) {
        this.getThirdChildren.results = []
        this.getFourthChildren.results = []
        this.getFifthChildren.results = []
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'fourth' && !val.is_active) {
        this.fourth = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'fourth' && val.is_active) {
        this.getFourthChildren.results = []
        this.getFifthChildren.results = []
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'fifth' && !val.is_active) {
        this.fifth = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'fifth' && val.is_active) {
        this.getFifthChildren.results = []
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'sixth' && !val.is_active) {
        this.sixth = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'sixth' && val.is_active) {
        this.getSixthChildren.results = []
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'seven' && !val.is_active) {
        this.seven = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'seven' && val.is_active) {
        this.getSevenChildren.results = []
        this.getEightChildren.results = []
      }
      if (name === 'eight' && !val.is_active) {
        this.eight = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'eight' && val.is_active) {
        this.getEightChildren.results = []
      }
      if (name === 'nine' && !val.is_active) {
        this.nine = val.module.id
        this.FETCH_PERMISSIONS_CHILDREN({
          role_id: this.$route.params.id,
          id: val.module.id,
          name: name,
          page_size: 1000
        })
      } else if (name === 'nine' && val.is_active) {
        // this.getEightChildren.results = []
      }
      if (val) {
        this.all_ids.push({id: val.module.id, is_active: !val.is_active})
      }
    },

    openChildren(val, name) {
      if (name === 'first') {
        this.first = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })
        } else {
          this.getFirstChildren.results = []
          this.getSecondChildren.results = []
          this.getThirdChildren.results = []
          this.getFourthChildren.results = []
          this.getFifthChildren.results = []
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }

      }
      if (name === 'second') {
        this.second = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })

        } else {
          this.getSecondChildren.results = []
          this.getThirdChildren.results = []
          this.getFourthChildren.results = []
          this.getFifthChildren.results = []
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }
      }
      if (name === 'third') {
        this.third = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })

        } else {
          this.getThirdChildren.results = []
          this.getFourthChildren.results = []
          this.getFifthChildren.results = []
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }
      }
      if (name === 'fourth') {
        this.fourth = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })

        } else {
          this.getFourthChildren.results = []
          this.getFifthChildren.results = []
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }
      }
      if (name === 'fifth') {
        this.fifth = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })

        } else {
          this.getFifthChildren.results = []
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }

      }
      if (name === 'sixth') {
        this.sixth = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })

        } else {
          this.getSixthChildren.results = []
          this.getSevenChildren.results = []
          this.getEightChildren.results = []
        }
      }
      if (name === 'seven') {
        this.seven = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })
        } else {
          this.getEightChildren.results = []
          this.getSevenChildren.results = []
        }

      }
      if (name === 'eight') {
        this.eight = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })
        } else {
          this.getEightChildren.results = []
        }
      }
      if (name === 'nine') {
        this.nine = val.module.id
        if (val.is_active) {
          this.FETCH_PERMISSIONS_CHILDREN({
            role_id: this.$route.params.id,
            id: val.module.id,
            name: name,
            page_size: 1000
          })
        }
      } else {
        // this.getEightChildren.results = []
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },

  created() {
    this.permission.role = JSON.parse(localStorage.getItem("namePermission"));

  },
  async mounted() {
    this.getFirstChildren.results = []
    this.getSecondChildren.results = []
    this.getThirdChildren.results = []
    this.getFourthChildren.results = []
    this.getFifthChildren.results = []
    this.getSixthChildren.results = []
    this.getSevenChildren.results = []
    this.getEightChildren.results = []
    await this.FETCH_PERMISSIONS_LIST({id: this.$route.params.id, page_size: 1000})
  },
};
</script>

<style lang="scss" scoped>

.hoverEffect:hover {
  transform: translateY(-2px);
  transition: all 0.4s;
}

.stripeBg {
  background: #f8f8f8;
}

.letter-space-0 {
  letter-spacing: 0;
}

.toggle {
  cursor: pointer;
  display: inline-block;
}

.hovered {
  background: rgb(0, 118, 166);
  color: white
}


.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 48px;
  height: 22px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;

  &:before,
  &:after {
    content: "";
  }

  &:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 14px;
    height: 14px;
    position: absolute;
    top: 4px;
    left: 4px;
    transition: left 0.25s;
  }

  .toggle:hover &:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
  }

  .toggle-checkbox:checked + & {
    background: cornflowerblue;

    &:before {
      left: 30px;
    }
  }
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}

.permission {
  display: flex;
  overflow: scroll;

  ul {
    min-width: 250px;
    max-width: 250px
  }
}

.loader {
  border: 6px solid #f3f3f3;
  border-radius: 80%;
  border-top: 5px solid #3498db;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
